<div class="back-to-section">
    <div class="arrow-container">
        <span class="icon icon_back_arrow" (click)="goToUrl()" ></span>
    </div>
    <div class="back-txt">
        <span  (click)="goToUrl()"   class="navigation-message">{{ locatinBtnNames.BACK_TO_LOCATIONS| customTranslation:translationData}}</span>
    </div>
</div>